/**
 * Resolve the `currentSubmissionDocument` value to persist when saving a
 * document, or undefined to leave the facility links' existing flags alone.
 *
 * Only submission document types can be current. A checkbox choice wins —
 * using `??` (not `||`) so an explicit `false` (unchecking) is respected.
 * An untouched checkbox falls back to the existing value, and when neither is
 * known the flag is left as it is.
 */
export function resolveCurrentSubmissionDocument({
  isKnownSubmissionType,
  formValue,
  existingValue,
}: {
  isKnownSubmissionType: boolean;
  formValue: boolean | null | undefined;
  existingValue: boolean | null | undefined;
}): boolean | undefined {
  if (!isKnownSubmissionType) {
    return false;
  }
  return formValue ?? existingValue ?? undefined;
}
